const toDate = (dateTime) => (dateTime.toDate ? dateTime.toDate() : new Date(dateTime));

/**
 * Short date/time split for meal cards: { date: "Jan 5", time: "3:00 PM", dayOfWeek: "Fri" }.
 * Callers that want "Fri, Jan 5 at 3:00 PM" compose `${dayOfWeek}, ${date} at ${time}`.
 */
export const formatMealDateTime = (dateTime) => {
  if (!dateTime) return { date: 'Date not set', time: '', dayOfWeek: '' };
  const date = toDate(dateTime);
  return {
    date: date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }),
    time: date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' }),
    dayOfWeek: date.toLocaleDateString('en-US', { weekday: 'short' }),
  };
};

/** Full single-string date/time, e.g. "Monday, January 5, 2026, 3:00 PM". */
export const formatLongDateTime = (dateTime) => {
  if (!dateTime) return 'Not set';
  const date = toDate(dateTime);
  return date.toLocaleDateString('en-US', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
};

/** Date-only, no time, e.g. "Jan 5, 2026". */
export const formatShortDate = (dateTime) => {
  if (!dateTime) return null;
  const date = toDate(dateTime);
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
};
